import { Button, Card, Form, Input } from "antd";
import { useNavigate } from "react-router";
import { useRequestOtpMutation } from "../../../app/features/auth/auth.api";
import { toast } from "../../../lib/toast";
import { errorToast } from "../../../utils/error.utils";
import Logo from "/images/logo.svg";

export default function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const defaultEmail = "farhan@upscalebd.com";
  const othersEmail = "hossainrabbi259@gmail.com";

  const [requestOtp, { isLoading }] = useRequestOtpMutation();

  const handleSubmit = async (values: any) => {
    try {
      if (values?.email !== defaultEmail && values?.email !== othersEmail) {
        toast("error", "Invalid email address");
        return;
      }
      // await requestOtp({ phone: normalizePhoneNumber(values.phone) }).unwrap();
      await requestOtp({ email: values.email }).unwrap();
      // navigate("/otp", { state: { phone: values.phone } });
      navigate("/otp", { state: { email: values.email } });
    } catch (error) {
      errorToast(error, "Failed to send OTP");
    }
  };

  return (
    <div className="flex h-screen flex-col md:flex-row">
      <div className="w-full relative bg-[#E9F2F2] flex items-center justify-center h-screen md:h-auto">
        {/* Centered Card */}
        <Card className="!max-w-96 shadow-xl sm:w-11/12" bordered={false}>
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={Logo} alt="Logo" className="h-14 w-auto" />
          </div>

          <div className="text-theme-zinc-700 text-xl font-semibold mb-6">
            Login
          </div>

          {/* Login Form */}
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{ email: defaultEmail }}
          >
            {/* <Form.Item
              label="মোবাইল নম্বর"
              name="phone"
              validateFirst
              rules={[
                { required: true, message: "মোবাইল নম্বর দিতে হবে!" },
                {
                  pattern: /^(?:\+880|880|0)1[3-9]\d{8}$/,
                  message: "বৈধ বাংলাদেশি মোবাইল নম্বর দিন",
                },
              ]}
            >
              <Input
                placeholder="আপনার মোবাইল নম্বর দিন"
                size="large"
                className="antd-input-primary"
              />
            </Form.Item> */}
            <Form.Item
              label="Email"
              name="email"
              // rules={[{ required: true, message: "Email is required!" }]}
            >
              <Input
                placeholder="name@example.com"
                size="large"
                className="antd-input-primary"
                // disabled
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              className="pt-2"
              loading={isLoading}
            >
              Send OTP
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
}
